import { AddCircle, Delete, Edit, Image } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAddFieldDataMutation, useGetAllFieldsQuery, useVehicleSubmitDatafieldMutation } from '../../../features/vehicle/AddFieldVehicleSlice';
import { useDeleteVehicleMutation, useGetVehicleTypeListQuery, useLazyGetAllFieldsForVehicleTypeQuery, useUpdateVehicleTypeWithFieldsMutation } from '../../../features/vehicle/GetVehicleFieldSlice';
import { useCustomData } from '../../Sidebar/Permission';
import Spinner from '../../Spinner';
import Dialog from '../../designSystem/Dialog';
import errorHandler from '../../hooks/ErrorHanlder';
import VehicleWrapper from './VehicleWrapper';

const AddVehicleType = () => {
    const [permission] = useCustomData();
    const [open, setOpen] = useState(false);
    const [editField, setEditField] = useState('')
    const [inputText, setInputText] = useState('');
    const [fieldType, setFieldType] = useState('');
    const [list, setList] = useState([]);
    const [file, setFile] = useState();
    const [disable, setDisable] = useState(false);
    const [checkedValue, setCheckedValue] = useState([]);
    const [inputFieldData, setInputFieldData] = useState([]);
    const [checkedData, setCheckedData] = useState({})
    const [show, setShow] = useState(false);
    const [newCheck, setNewCheck] = useState({})
    const { register, setValue, handleSubmit, formState: { errors }, reset, setError, clearErrors } = useForm();
    const [addFieldData] = useAddFieldDataMutation();
    const { data: fieldsData, refetch: getData, isLoading: AllFieldsLoading } = useGetAllFieldsQuery();
    const [vehicleSubmitDatafield] = useVehicleSubmitDatafieldMutation();
    const { data: vehicleList, isLoading, refetch } = useGetVehicleTypeListQuery({ refetchOnMountOrArgChange: true });

    const tableList = vehicleList?.data
    const [setRowId, rowDatas] = useLazyGetAllFieldsForVehicleTypeQuery()
    const rowId = rowDatas?.data?.data?.vehicleTypeId
    const [updateVehicleTypeWithFields] = useUpdateVehicleTypeWithFieldsMutation();
    const [deleteId, setDeleteId] = useState()
    const [deleteVehicle] = useDeleteVehicleMutation()

    useEffect(() => {
        setInputFieldData(fieldsData?.data)
    }, [fieldsData, list])

    const addList = async (inputText) => {
        const fieldsToCheck = [
            {
                value: fieldType,
                name: "fieldType",
                message: "Please select a field type"
            },
            {
                value: inputText.trim(),
                name: "Addmorefield",
                message: "Please enter a field name"
            }
        ];
        let hasError = false;
        fieldsToCheck.forEach(({ value, name, message }) => {
            if (!value) {
                setError(name, { type: "required", message });
                hasError = true;
            } else {
                clearErrors(name);
            }
        });
        if (hasError) return;
        setList([...list, inputText, fieldType])
        let newdata = {
            fieldName: inputText,
            fieldType
        }
        await addFieldData(newdata)
        getData()
        setInputText("");
        setFieldType("")
    }
    const checkHandler = (e, listItem) => {
        let updatedCheckedData = { ...checkedData };
        let updatedCheckedValue = [...checkedValue];

        if (e.target.checked) {
            // Set the item as checked
            updatedCheckedData[e.target.name] = true;

            // Only add unique field IDs
            if (!updatedCheckedValue.some((item) => item.fieldId === listItem?.fieldId)) {
                updatedCheckedValue.push({ fieldId: listItem?.fieldId });
            }
        } else {
            // Set the item as unchecked
            updatedCheckedData[e.target.name] = false;

            // Remove the unchecked field from the list
            updatedCheckedValue = updatedCheckedValue.filter(
                (data) => data?.fieldId !== listItem?.fieldId
            );
        }

        // Update both state variables
        setCheckedData(updatedCheckedData);
        setCheckedValue(updatedCheckedValue);
    };

    function handleChange(e) {
        try {
            const img = (e.target.files[0]);
            if (img.size > 10e5) {
                toast.info("Please upload a file smaller than 1 MB", {
                    position: "top-center",
                })
            }
            else {
                setFile(img);
                return;
            }
        }
        catch {
            toast.warning("An Error Occured!", {
                position: "top-center",
            })
        }

    }
    const handleDeleteVehicle = async () => {
        try {
            setOpen(false);
            await deleteVehicle(deleteId).unwrap()
            toast.success("Vehicle deleted successfully!", {
                position: "top-center",
            })
            refetch()
        }
        catch (error) {
            errorHandler(error)
        }
    };

    useEffect(() => {
        if (rowDatas?.data?.data) {
            // Reset the state before setting new values
            setCheckedData({});
            setCheckedValue([]);
            setNewCheck({});

            // Set the vehicle type description and image path
            setValue("vehicle_type", rowDatas?.data?.data?.vehicleTypeDescription);
            rowDatas?.data?.data?.imagePath && setFile(rowDatas?.data?.data?.imagePath);

            // Map through the field details and set the checkbox states
            if (rowDatas?.data?.data?.fieldDetailsDTO?.length > 0) {
                const newCheckedData = {};
                const newCheckedValues = [];
                const newCheckMap = {};

                rowDatas?.data?.data?.fieldDetailsDTO.forEach((d) => {
                    if (d?.fieldName !== null) {
                        newCheckedData[d?.fieldName] = true;
                        newCheckedValues.push({ fieldId: d?.fieldId });
                        newCheckMap[d?.fieldName] = d?.fieldId;
                    }
                });

                setCheckedData(newCheckedData);
                setCheckedValue(newCheckedValues);
                setNewCheck(newCheckMap);
            }
        }
    }, [rowDatas, setValue]);

    useEffect(() => {
        let arr = []
        for (const id of Object.values(newCheck)) {
            arr.push({ "fieldId": id })
        }
        setCheckedValue(arr)
    }, [newCheck, rowDatas])

    const onSubmit = async (data) => {
        try {
            let arr2 = []
            for (let key1 in checkedData) {
                if (checkedData[key1]) {
                    arr2.push({ [key1]: newCheck[key1] })
                }
            }
            let formdata = new FormData();
            formdata.append("vehicleTypeDescription", data?.vehicle_type);
            formdata.append("ImagePathDescription", file);
            formdata.append("fieldDetails", JSON.stringify(checkedValue));
            await vehicleSubmitDatafield(formdata).unwrap();
            setFile(null)
            refetch()
            setCheckedData({})
            setCheckedValue([]);
            reset({ vehicle_type: "", checkedValue: "" });
            toast.success("Vehicle added successfully!", {
                position: "top-center",
            })
        }
        catch (error) {
            errorHandler(error)
        }

    }

    const updateVehicle = async (data) => {
        try {
            let arr2 = []
            for (let key1 in checkedData) {
                if (key1 == null) return;
                if (checkedData[key1] != null) {
                    arr2.push({ fieldId: newCheck[key1] })
                }
            }
            const fieldData = checkedValue.filter((data) => data?.fieldId)
            let formdata1 = new FormData();
            formdata1.append("vehicleTypeDescription", data?.vehicle_type);
            formdata1.append("vehicleTypeId", rowId);
            formdata1.append("ImagePathDescription", file);
            formdata1.append("fieldDetails", JSON.stringify(fieldData));
            await updateVehicleTypeWithFields(formdata1).unwrap()
            setFile(null)
            reset({ vehicle_type: "", checkedValue: "" });
            setCheckedData({})
            setNewCheck({})
            setShow(false)
            refetch()
            toast.success("Vehicle updated Succesfully!", {
                position: "top-center",
            })
            setDisable(false)
        }
        catch (error) {
            errorHandler(error)
        }
    }

    if (isLoading) return <><Spinner /></>;

    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 140,
            disableClickEventBubbling: true,
            renderCell: (data) => {
                const onClick = (data) => {
                    setCheckedValue([]); // Clear the previously checked values
                    setCheckedData({});
                    setRowId(data?.id)
                    setEditField(data?.row?.Vehicle)
                    refetch()
                    setShow(true)
                    setDisable(true)
                };
                const onRemove = (data) => {
                    setDeleteId(data?.id)
                    setOpen(true);
                };

                return (
                    <>
                        <div className="action_btn">

                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Update') !== -1 ?
                                <span className="edit_btn" onClick={() => onClick(data)}><Edit /></span>
                                : <span className="edit_btn disable"><Edit /></span>
                            }

                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Delete') !== -1 ?
                                <span className="del_btn" onClick={() => onRemove(data)}><Delete /></span> :
                                <span className="del_btn disable"><Delete /></span>}
                        </div>
                        <Dialog show={open} title="Delete Confirmation" description="Are you sure you want to delete this row?" onClose={() => setOpen(false)} onSubmit={handleDeleteVehicle} />
                    </>
                )
            },
        },
        { field: "Vehicle", headerName: "Vehicle", width: 250 },
    ];

    const rows = tableList?.map((data) => {
        return {
            id: data?.vehicleTypeId,
            Vehicle: data?.vehicleTypeDescription,
        }
    })
    const onCancel = () => {
        reset({ vehicle_type: "" });
        clearErrors();
        setFile(null);
        setCheckedData({});
        setCheckedValue([]);
        setNewCheck({});
        setShow(false);
        setDisable(false);
        setEditField("");
        setInputText("");
        setFieldType("");
    }

    const submitHandler = show
        ? handleSubmit(updateVehicle)
        : handleSubmit(onSubmit);
    return (
        <>
            {AllFieldsLoading && <Spinner />}
            <VehicleWrapper
                onCancel={onCancel}
                isEdit={editField}
                onSubmit={submitHandler}
                rows={rows}
                columns={columns}
                listTitle="Add Vehicle Type"
                label="Add Field You Would Like To Add For The Item Descriptions">

                <VehicleWrapper.SectionOne>
                    <Row>
                        <Col sm={2}>
                            <div className="image-upload-section inventory">
                                <div className="employee-image-upload img-vehicle">{file ? (
                                    <img
                                        alt="vehicle"
                                        key={file}
                                        src={typeof file === "string" ? file : URL?.createObjectURL(file)}
                                    />
                                ) : (
                                    <Image />
                                )}</div>
                                <div className="upload-btn"> <p >Upload Image</p></div>
                                <input type="file" onChange={handleChange} className="image-upload-btn" accept=".jpg,.png" />
                            </div>
                        </Col>
                        <Col sm={3}>
                            <div className="form-floating">
                                <Form.Control type="text" autoComplete="off" defaultValue={editField} disabled={disable} placeholder="Add a Vehicle Type" name="vehicle_type" {...register('vehicle_type', { required: 'Field is required', pattern: /^[^-\s][a-zA-Z0-9_\s-]+$/ })} />
                                <label htmlFor="Item">Add a Vehicle Type</label>
                                <p className="error-message">{errors?.vehicle_type?.message}</p>
                            </div>
                        </Col>
                    </Row>
                </VehicleWrapper.SectionOne>
                <Row>
                    <Col sm={12} md={3} lg={5} />
                    <Col sm={12} md={12} lg={7}>
                        <Row className='justify-content-end'>
                            <Col sm={12} md={5} lg={4} className="pe-0">
                                <FloatingLabel controlId="floatingSelectGrid" label="Select Field Type">
                                    <Form.Select
                                        aria-label="Floating label select example"
                                        name="fieldType"
                                        value={fieldType}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val !== "Select") {
                                                setFieldType(val);
                                                if (val) {
                                                    clearErrors("fieldType");
                                                } else {
                                                    setError("fieldType", {
                                                        type: "required",
                                                        message: "Please select a field type",
                                                    });
                                                }
                                            }
                                        }}
                                        required
                                    >
                                        <option value="">Select</option>
                                        {["Text", "Dropdown"]?.map((value) => (
                                            <option key={value} value={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                                {errors.fieldType && (
                                    <p className="error-message">{errors.fieldType.message}</p>
                                )}
                            </Col>
                            <Col sm={12} md={5} lg={4} className="pe-0">
                                <div className="form-floating">
                                    <Form.Control type="text" autoComplete="off" placeholder="Add more field" name="Addmorefield"
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setInputText(val);
                                            if (val.trim()) {
                                                clearErrors("Addmorefield");
                                            } else {
                                                setError("Addmorefield", {
                                                    type: "required",
                                                    message: "Please enter a field name",
                                                });
                                            }
                                        }} value={inputText} />
                                    <label htmlFor="Add more field">Add more field</label>
                                    {errors.Addmorefield && (
                                        <p className="error-message">{errors.Addmorefield.message}</p>
                                    )}
                                </div>
                            </Col>
                            <Col sm={12} md={2} lg={"auto"}>
                                {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Add') !== -1 ?
                                    <Button className="btn btn-secondary" onClick={() => { addList(inputText); setInputText(""); setFieldType("") }}><AddCircle /> Add </Button>
                                    :
                                    <Button className="btn btn-secondary disable"><AddCircle /> Add </Button>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {/* Checkbox section */}
                <div className="mt-4 discriptionBox">
                    {inputFieldData && [...inputFieldData]
                        .sort((a, b) => {
                            if (a.isDefaultField && !b.isDefaultField) return -1;
                            if (!a.isDefaultField && b.isDefaultField) return 1;
                            return 0;
                        })?.map((listItem, id) => {
                            return (
                                <div key={id} className="form-check form-check-inline boxHoverNew">
                                    <div className="form-group">
                                        <input className="form-check-input" key={checkedData[listItem?.fieldName]} checked={checkedData[listItem?.fieldName]} type="checkbox" value={listItem?.fieldId} name={listItem?.fieldName} onClick={(e) => checkHandler(e, listItem)} />
                                        <label className="form-check-label" htmlFor="inlineCheckbox1"> {listItem?.fieldName}</label>
                                    </div>
                                </div>
                            )
                        }
                        )}
                </div>
            </VehicleWrapper >
        </>
    )
}

export default AddVehicleType;
